<template>
  <div class="seckill-grid-block-component">
    <div class="seckill-grid-block-container">
      <div class="seckill-grid-block-header">
        <ym-img class="seckill-grid-block-title"
                :src="block.title"
        />
        <div v-if="currentSeckill && currentSeckill.startTime > 0"
             class="seckill-grid-block-seckill-time"
        >
          <div class="seckill-grid-block-seckill-time-name">
            秒杀时间
          </div>
          <highlight-time :time="currentSeckill.startTime" />
        </div>
      </div>
      <div class="seckill-grid-block-list">
        <grid-item v-for="item in block.list"
                   :key="item.target.id"
                   :item="item"
                   :start-time="currentTime"
                   @show-guide-mask="handleShowGuideMask"
                   @show-book-mobile="handleShowBookPopup"
                   @show-next-seckill="handleShowNextSeckill"
        />
      </div>
    </div>

    <template v-if="currentSeckill">
      <div class="seckill-grid-block-show-rule"
           @click="handleShowRule"
      >
        查看秒杀规则
      </div>
      <rule-popup :show.sync="showRulePopup"
                  :rule="currentSeckill.rule"
      />
    </template>
  </div>
</template>

<script>
  import GridItem from '@/pages/Seckill/components/SeckillGridItem';
  import RulePopup from '@/pages/Seckill/components/SeckillRulePopup';
  import HighlightTime from '@/pages/Seckill/components/SeckillHighlightTime';

  export default {
    name: 'SeckillGridBlock',
    components: {
      GridItem,
      RulePopup,
      HighlightTime,
    },
    props: {
      block: {
        type: Object,
        required: true,
      },
      currentTime: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        showRulePopup: false,
      };
    },
    computed: {
      currentSeckill() {
        const { length } = this.block.list;
        if (length === 0) {
          return {
            startTime: 0,
            rule: '',
          };
        }
        return this.block.list[0].seckill;
      },
    },
    methods: {
      handleShowBookPopup(target) {
        this.$emit('show-book-mobile', target);
      },
      handleShowNextSeckill(next) {
        this.$emit('show-next-seckill', next);
      },
      handleShowRule() {
        this.showRulePopup = true;
      },
      handleShowGuideMask() {
        this.$emit('show-guide-mask');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .seckill-grid-block {
    &-component {
      text-align: center;
    }

    &-container {
      overflow: hidden;
      border-radius: @seckill-item-border-radius;
      box-shadow: @seckill-item-shadow;
    }

    &-header {
      overflow: hidden;
      height: 100px;
      display: flex;
      padding: 0 @size-base;
      align-items: center;
      justify-content: space-between;
      color: @color-white;
      background: @seckill-header-background;
    }

    &-title {
      width: 297px;
      height: 50px;
      flex-shrink: 0;
    }

    &-seckill-time {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      line-height: 1;

      &-name {
        margin-right: @size-extra-small;
        opacity: .8;
      }
    }

    &-list {
      padding-bottom: @size-medium;
      background: @color-white;
    }

    &-show-rule {
      display: inline-block;
      margin: @size-base auto 0;
      text-align: center;
      color: @seckill-text-dark;
      border-bottom: 1px solid @seckill-text-dark;
    }
  }
</style>
